import { IconButton, Menu, MenuItem } from "@mui/material";
import { useState } from "react";

const CustomerActionMenu = ({
  row,
  doSetUser,
  setIsUpdate,
  setIsCancel,
  setIsSkipBill,
  setIsPause,
  setIsResume,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="flex flex-wrap gap-1">
      <div>
        <IconButton
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="size-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM18.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
            />
          </svg>
        </IconButton>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          slotProps={{
            list: {
              "aria-labelledby": "basic-button",
            },
          }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <MenuItem
            onClick={() => {
              doSetUser(row);
              setIsUpdate(true);
            }}
            disabled={row.status !== 1}
          >
            Update
          </MenuItem>
          <MenuItem
            onClick={() => {
              doSetUser(row);
              setIsCancel(true);
            }}
            disabled={row.status === 2}
          >
            Cancel
          </MenuItem>
          <MenuItem
            onClick={() => {
              doSetUser(row);
              setIsSkipBill(true);
            }}
            disabled={!(row.status === 1 && row.delivery_status === 2)}
          >
            Skip Billing Cycle
          </MenuItem>
          {[1, 2].includes(row.status) && (
            <MenuItem
              onClick={() => {
                doSetUser(row);
                setIsPause(true);
              }}
              disabled={row.status === 2}
            >
              Pause Subscription
            </MenuItem>
          )}
          {row.status === 4 && (
            <MenuItem
              onClick={() => {
                doSetUser(row);
                setIsResume(true);
              }}
            >
              Resume Subscription
            </MenuItem>
          )}
        </Menu>
      </div>
    </div>
  );
};

export default CustomerActionMenu;
